// extracted by mini-css-extract-plugin
module.exports = {"Content":"WarrantyUser_Content__x1QnX","Text":"WarrantyUser_Text__TRm5k","WrapperList":"WarrantyUser_WrapperList__8gFbP","Notificate":"WarrantyUser_Notificate__Eyt5N"};